/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {Component, ElementRef, Input, OnInit, ViewChild} from "@angular/core";

import { BehaviorSubject, tap } from "rxjs";
import { DirectoryItemModel } from "../../models/directory-item.model";
import { DirectorySearchService } from "../../services/directory-search.service";
import { GoogleMapService } from "../google-map/google-map.service";
import { DirectoryTemplateId } from "../../enums/directory-template-id.enum";

@Component({
    selector: "pcg-ng-directory-item-details-card",
    templateUrl: "./directory-item-details-card.component.html"
})
export class DirectoryItemDetailsCardComponent implements OnInit{
    @Input() public itemToDisplay: DirectoryItemModel;
    @Input() public viewPageUrl: string;
    @Input() public defaultImageUrl: string;

    public directoryItem$: BehaviorSubject<DirectoryItemModel>;
    public iss4sLoading: boolean;
    public isImageLoading = true;

    @ViewChild("addToBookletButton", { read: ElementRef, static: false })
    private addToBookletButtonRef: ElementRef;

    private tagMappings: { [key: string]: { tagCaption: string, tagModifier: string } } = {
        [DirectoryTemplateId.COMMUNITY_DIRECTORY]: { tagCaption: "Community directory", tagModifier: "violet" },
        [DirectoryTemplateId.MARKETPLACE]: { tagCaption: "Marketplace", tagModifier: "yellow" },
        [DirectoryTemplateId.HOME_CARE]: { tagCaption: "Home Care", tagModifier: "red" },
        [DirectoryTemplateId.CARE_HOMES]: { tagCaption: "Care Homes", tagModifier: "green" }
    };

    private readonly NATIONAL_TAG_ID: string = "8FCD7AAE-4E4A-41BA-A63A-A80000FCBB53";

    public constructor(
        private directorySearchService: DirectorySearchService,
        private googleMapService: GoogleMapService
    ) {
    }

    public ngOnInit(): void {
        this.directoryItem$ = new BehaviorSubject<DirectoryItemModel>(this.itemToDisplay);
        this.iss4sLoading = true;
        this.directorySearchService.getDirectoryItem(this.itemToDisplay.id)
            .pipe(
                tap(() => this.iss4sLoading = false),
                tap(r => this.googleMapService.addMarker(r, this.viewPageUrl))
            )
            .subscribe(
                r => {
                    const directoryItem = this.directoryItem$.getValue();
                    const templateIdProperty = directoryItem?.properties?.find(p => p.alias === "TemplateId");
                    const templateId = templateIdProperty?.value;

                    const updatedItem = {
                        ...r,
                        templateId: templateId
                    };

                    this.directoryItem$.next(updatedItem);
                }
            );
    }

    public getDetailsPageUrl(): string {
        if (!this.itemToDisplay || !this.viewPageUrl) return "#";

        const url = new URL(this.viewPageUrl, window.location.origin);
        url.searchParams.set("id", this.itemToDisplay.id);
        url.searchParams.set("returnUrl", window.location.href);

        return url.href;
    }

    public imageLoaded(): void {
        this.isImageLoading = false;
    }

    public getTagCaption(templateId: string): string | null {
        return this.tagMappings[templateId]?.tagCaption || null;
    }

    public getTagModifier(templateId: string): string | null {
        return this.tagMappings[templateId]?.tagModifier || null;
    }

    public hasNationTag(): boolean | null {
        return this.directoryItem$.getValue().attributes.some(attribute => attribute.id.toUpperCase() === this.NATIONAL_TAG_ID);
    }
}
